import React, {Component} from 'react';

import {
    BrowserRouter as Router,
    Route,
    Link
} from 'react-router-dom';

import Api from '../Service/Api.js';
import ContactForm from './ContactForm';

const footer =
    <div className="knowledge-footer">
        Have not found what you are looking for? <Link to={"/ask"}>Contact us</Link>
    </div>;

export default class Knowledge extends Component {

    constructor(props) {
        super(props);

        this.state = {
            search: '',
            folders: [],
            knowledge: [],
            index: {
                folders: [],
                knowledge: []
            },
            loading: true,
            ask: false
        };

        this.loadComplete = this.loadComplete.bind(this);
        this.search = this.search.bind(this);
        this.setSearch = this.setSearch.bind(this);
    }

    componentWillMount() {
        // load knowledge
        this.loaded = 0;
        this.loadFolders(this.loadComplete);
        this.loadKnowledge(this.loadComplete);
    }

    dataLoaded(callback) {
        this.loaded++;
        if (this.loaded >= 2) {
            callback();
        }
    }

    loadComplete() {
        console.log('load complete');
        this.setState({loading: false});
    }

    loadFolders(callback) {
        Api.requestGet('/folder', (data) => {
            // parse tree
            let folders = [];
            let index = [];
            // index all items first
            for (let i = 0; i < data.list.length; i++) {
                let item = data.list[i];
                item.children = [];
                index[item.id] = item;
            }
            // build a tree
            for (let i = 0; i < data.list.length; i++) {
                let item = data.list[i];
                if (item.parent > 0 && typeof(index[item.parent]) !== 'undefined') {
                    index[item.parent].children.push(item);
                } else {
                    folders.push(item);
                }
            }
            this.setState({folders: folders});
            this.dataLoaded(callback);
        }, function () {
            alert('An error occured');
        });
    }

    indexKnowledge(knowledge) {
        let index = {
            folders: [],
            knowledge: []
        };
        for (let i = 0; i < knowledge.length; i++) {
            let item = knowledge[i];
            if (typeof index.folders[item.folder] === 'undefined') {
                index.folders[item.folder] = [];
            }
            index.folders[item.folder].push(item);
            index.knowledge[item.id] = item;
        }
        this.setState({index: index});
    }

    loadKnowledge(callback) {
        Api.requestGet('/knowledge', (data) => {
            this.setState({knowledge: data.list});
            this.indexKnowledge(data.list);
            this.dataLoaded(callback);
        }, this.authError);
    }



    setSearch(search) {
        this.setState({search: search});
    }

    search(event) {
        event.preventDefault();
        this.setState({search: event.target.value});
        if (this.props.location.pathname != '/') {
            this.props.history.push('/');
        }
    }

    getFilteredList() {
        let matches = {};
        let keywords = this.state.search.toLowerCase().split(/[ ,.;?]+/);
        for (let i = 0; i < this.state.knowledge.length; i++) {
            let item = this.state.knowledge[i];
            let match = {
                matches: 0,
                item: item
            };
            if (typeof matches[item.id] !== 'undefined') {
                match = matches[item.id];
            }

            let directMatch = item.question.toLowerCase().indexOf(this.state.search.toLowerCase());
            if (directMatch !== -1) {
                match.matches = 1000 - directMatch;
            }
            for (let k = 0; k < keywords.length; k++) {
                let keyword = keywords[k];
                // only search for keywords with length more than 1
                if (keyword.length > 1) {
                    if (item.question.toLowerCase().indexOf(keyword) !== -1 || item.answer.toLowerCase().indexOf(keyword) !== -1) {
                        match.matches++;
                    }
                }
            }
            // add the match if found more than 66% of keywords
            if (match.matches >= keywords.length * 0.66) {
                matches[item.id] = match;
            }
        }
        let matchArray = [];
        for (let i in matches) {
            matchArray.push(matches[i]);
        }
        let sortedMatches = matchArray.sort((a, b) => (a.matches - b.matches));
        let result = [];
        for (let i = 0; i < sortedMatches.length; i++) {
            result.push(sortedMatches[i].item);
        }
        return result;
    }

    render() {

        const searchForm = (
            <form className="flunx-knowledge-search">
                <input type="text" className="form-control" name="searchterm"
                       placeholder="Enter a question, keyword or a topic"
                       value={ this.state.search }
                       onChange={ this.search }
                />
            </form>
        );

        let filteredList = this.getFilteredList();

        const childProps = {
            index: this.state.index,
            list: this.state.knowledge,
            filteredList: filteredList,
            search: this.state.search,
            folders: this.state.folders,
            basename: this.props.basename,
            app: this
        };

        const body = this.state.loading ? (
                <div className="col-md-12 knowledge-base">
                    <div className="loading"></div>
                </div>
            ) : (
                <div className="col-md-12 knowledge-base">
                    {searchForm}
                    <div className="knowledge-body">
                        <Route exact path={"/folder/:folder"}
                               render={(props) => <FolderList {...props} {...childProps} />}/>
                        <Route exact path={"/question/:question"}
                               render={(props) => <KnowledgeDetail {...props} {...childProps} />}/>
                        <Route exact path={"/ask"} render={(props) => <ContactForm {...props} {...childProps} />}/>
                        <Route exact path={"/"} render={(props) => <KnowledgeDashboard {...props} {...childProps} />}/>
                    </div>
                    <div className="loading"></div>
                </div>
            );

        return (
            <div className="row">
                {body}
            </div>
        )
    }
}

export class KnowledgeDashboard extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const maxSubFolders = 3;
        const maxSubItems = 5;
        if (this.props.search != '') {
            return <KnowledgeList {...this.props} />
        }
        let dashboardItems = [];
        for (let i = 0; i < this.props.folders.length; i++) {
            let folder = this.props.folders[i];
            if (folder.parent == 0) {
                let children = [];
                let subFolders = [];
                for (let i = 0; i < folder.children.length && i < maxSubFolders; i++) {
                    let subFolder = folder.children[i];
                    subFolders.push(
                        <li key={subFolder.id}>
                            <Link to={"/folder/" + subFolder.id}><strong>{subFolder.name}</strong></Link>
                        </li>
                    )
                }
                if (typeof this.props.index.folders[folder.id] !== 'undefined' && this.props.index.folders[folder.id] !== null) {
                    for (let i = 0; i < maxSubItems && i < this.props.index.folders[folder.id].length; i++) {
                        let child = this.props.index.folders[folder.id][i];
                        children.push(
                            <li key={child.id}>
                                <Link to={"/question/" + child.id}>{child.question}</Link>
                            </li>
                        )
                    }
                }
                dashboardItems.push(
                    <div className="knowledge-dashboard-item" key={folder.id}>
                        <h3>{folder.name}</h3>
                        <ul>
                            {subFolders}
                            {children}
                        </ul>
                        <Link to={"/folder/" + folder.id} className="btn btn-primary btn-sm">Show more</Link>
                    </div>
                )
            }
        }
        return (
            <div>
                <div className="knowledge-dashboard">
                    {dashboardItems}
                </div>
                {footer}
            </div>
        );
    }
}

export class KnowledgeList extends Component {

    constructor(props) {
        super(props);
    }


    render() {


        let show = null;
        if (this.props.filteredList.length === 0) {
            show = <div>
                <ContactForm {...this.props} showNotFound={true}/>
            </div>
        } else {
            show =
                <div>
                    <ul>
                        {this.props.filteredList.map(child => {
                            return (
                                <li key={child.id}>
                                    <Link to={"/question/" + child.id}>{child.question}</Link>
                                </li>
                            );
                        })}
                    </ul>
                    {footer}
                </div>
        }

        return (
            <div>
                {show}
            </div>
        )
    }

}

export class FolderList extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        document.body.scrollTop = 0;
    }

    getFolder() {
        console.log('folders', this.props.folders);
        console.log('folders', parseInt(this.props.match.params.folder));
        for (let i = 0; i < this.props.folders.length; i++) {
            let folder = this.props.folders[i];
            console.log(folder.id, parseInt(this.props.match.params.folder));
            if (folder.id == parseInt(this.props.match.params.folder)) {
                return folder;
            }
        }
        return false;
    }

    render() {
        const folder = this.getFolder();
        console.log(folder);

        if (!folder) {
            return null;
        }

        let children = [];
        let subFolders = [];
        for (let i = 0; i < folder.children.length; i++) {
            let subFolder = folder.children[i];
            subFolders.push(
                <li key={subFolder.id}>
                    <Link to={"/folder/" + subFolder.id}><strong>{subFolder.name}</strong></Link>
                </li>
            )
        }
        if (typeof this.props.index.folders[folder.id] !== 'undefined' && this.props.index.folders[folder.id] !== null) {
            for (let i = 0; i < this.props.index.folders[folder.id].length; i++) {
                let child = this.props.index.folders[folder.id][i];
                children.push(
                    <li key={child.id}>
                        <Link to={"/question/" + child.id}>{child.question}</Link>
                    </li>
                )
            }
        }

        return (
            <div className="folder-detail">
                <h3>{folder.name}</h3>
                <ul>
                    {subFolders}
                    {children}
                </ul>
                <Link to="/" className="btn btn-primary btn-sm">Back</Link>
                {footer}
            </div>
        )
    }

}

export class KnowledgeDetail extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        document.body.scrollTop = 0;
    }

    render() {

        const knowledge = this.props.index.knowledge[parseInt(this.props.match.params.question)];

        if (!knowledge) {
            return (
                <div className="bg-error">
                    <h2>The question you are looking for was not found</h2>
                    <p><Link to={"/"}>Go back</Link></p>
                </div>
            )
        }

        let related = [];
        for (let i = 0; i < knowledge.related.length; i++) {
            if (typeof this.props.index.knowledge[knowledge.related[i]] !== 'undefined' && this.props.index.knowledge[knowledge.related[i]]) {
                let relatedItem = this.props.index.knowledge[knowledge.related[i]];
                related.push(
                    <li key={relatedItem.id}>
                        <Link to={"/question/" + relatedItem.id}>{relatedItem.question}</Link>
                    </li>
                );
            }
        }
        if (related.length) {
            related = (
                <div className="knowledge-related">
                    <h4>Related question(s):</h4>
                    <ul>{related}</ul>
                </div>
            )
        }
        const backLink = this.props.history.length > 1
            ?
            <a onClick={ event => {
                event.preventDefault();
                this.props.history.goBack();
            }} href="#">Back</a>
            :
            <Link to={"/folder/" + knowledge.folder}>Back</Link>;

        return (
            <div>
                <div className="knowledge-detail">
                    <h3>{knowledge.question}</h3>
                    <div className="knowledge-answer" dangerouslySetInnerHTML={ {__html: knowledge.answer} }></div>
                    {backLink}
                    {related}
                </div>
                {footer}
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/Components/Knowledge.jsx